export default "__VITE_ASSET__tgqnuREn__"